import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import logoC from '../img/logo-c.png';
import logoDK from '../img/logo-dk.png';


class Footer extends Component {


    render() {
        return (
            <div>
            <div className="main-container row5Home">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <img src={logoDK} alt="Automated Concepts" width="300px" />
                        </div>



                    </div>
                </div>
            </div>





            <div className="main-container row6Home">
                <div className="container row6bHome">
                    <div className="row ulno">

                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">

                            <div>
                                <ul className="noListStyleTip">
                                    <li>
                                        <h4>SERVICES</h4></li>
                                        <li><a href="/custom-applications"><span style={{ color: 'white' }}>Custom Applications</span></a></li>
                                        <li><a href="/technology-support"><span style={{ color: 'white' }}>Technology Support</span></a></li>
                                        <li><a href="/business-continuity"><span style={{ color: 'white' }}>Business Continuity</span></a></li>
                                        <li><a href="/it-support-network-audit"><span style={{ color: 'white' }}>IT Support Network Audit</span></a></li>
                                </ul>
                            </div>
                        </div>


                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">

                            <div>
                                <ul className="noListStyleTip">
                                    <li>
                                        <h4>INDUSTRIES</h4></li>
                                    <li>Manufacturing</li>
                                    <li>Healthcare</li>
                                    <li>Trade Shows</li>
                                    <li>Financial Services</li>
                                    <li>Retail</li>
                                    <li>Real Estate</li>
                                    <li>Many more...</li>
                                </ul>
                            </div>
                        </div>

                        {/*
                        <div className="col-lg-3 col-md-3 col-sm-3 col-xs-12">

                            <div>
                                <ul className="noListStyleTip">
                                    <li>
                                        <h4>ABOUT US</h4></li>
                                    <li>aasdf</li>
                                    <li>asf</li>
                                    <li>asdfasdfsadf asdf</li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                            </div>
                        </div>
                        */}

                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12">

                            <div>
                                <ul className="noListStyleTip">
                                    <li><h4>CONTACT US</h4></li>
                                        <li><a href="/support-request"><span style={{ color: 'white' }}>Need Help Now</span></a></li>
                                        <li><a href="/contact-us"><span style={{ color: 'white' }}>General Inquiry / Request</span></a></li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
            </div>



            <div className="main-container row7Home">
                <div className="container" >



                    <div className="row">

                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div style={{ padding: '40px' }}>
                                <p> <span className="fa fa-linkedin-square" style={{ fontSize: '30px' }}></span> &nbsp; &nbsp;
           <span className="fa fa-facebook-square" style={{ fontSize: '30px' }}></span></p></div>
                        </div>

                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right">

                            <p style={{ paddingRight: '20px' }}>South Windsor, CT<br /><br />

                                &copy; Automated Concepts, LLC<br />
                                All rights reserved.</p><br /><br /><br />
                        </div>


                    </div>

                </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer.js